<template>
  <div style="height:100%;position:relative">
    <div class="container">
      <div class="loginContainer">
        <el-row type="flex" justify="center" class="loginTitle">厦门力元、天协力信息管理系统</el-row>
        <!-- <el-row type="flex" justify="center" class="loginTitle">学习管理系统</el-row> -->
        <div class="mainLogin">
          <el-form label-width="50px" style="padding-top:10px">
            <el-form-item prop="username">
              <el-input v-model="loginForm.username" placeholder="用户名" class="loginInput"></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="loginForm.password" placeholder="密码" class="loginInput"></el-input>
            </el-form-item>
            <el-form-item prop="code">
              <el-input v-model="loginForm.code" placeholder="验证码" class="loginInput" style="width:90px"></el-input>
              <el-image @click="getCaptcha" style="width:88px;height:38px;vertical-align:bottom;margin-left:20px;border-radius: 8px;border: 1px solid #DCDFE6" :src="captchaURL" title="点击刷新">
                <span style="padding-left:20px;text-align:center" slot="error">加载中...</span>
              </el-image>
            </el-form-item>
            <el-form-item>
              <el-button @click="checkLogin" class="loginBtn" style="width:200px;border-radius: 8px;background-color: rgba(0,0,0,0.4);">
                登录
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="logoContainer">
        <img src="../assets/lyLogo.jpg" style="left:0px;top:0px"/>
        <img src="../assets/txlLogo.jpg" style="left:100px;top:0px"/>
      </div>
    </div>
    <div style="position:absolute;text-align:center;bottom:10px;width:100%"><el-link type="danger" :underline="false" href="https://beian.miit.gov.cn/" target="_blank"><span style="font-size:18px">备案号:闽ICP备20009292号</span></el-link></div>
  </div>
</template>

<script>
import { getCaptcha, checkLogin } from '../api/login'
import MD5 from 'md5.js'
export default {
  data () {
    return {
      captchaURL: '',
      loginForm: {
        username: '',
        password: '',
        code: ''
      }
    }
  },
  created () {
    this.getCaptcha()
  },
  methods: {
    checkLogin () {
      // md5(md5(username首字母)+md5(password))
      const usernameIndex0MD5 = new MD5()
      const passwordMD5 = new MD5()
      const Md5 = new MD5()
      const password = Md5.update((usernameIndex0MD5.update(this.loginForm.username.charAt()).digest('hex') + passwordMD5.update(this.loginForm.password).digest('hex'))).digest('hex')
      const params = {
        username: this.loginForm.username,
        code: this.loginForm.code,
        password
      }
      checkLogin(params).then(res => {
        if (res.data.status === 200) {
          this.$message.success('登录成功')
          localStorage.setItem('token', res.data.data.token)
          this.$router.push('/home/index')
        } else {
          this.getCaptcha()
          this.$message.error(res.data.msg)
          this.loginForm.code = ''
        }
      })
    },
    getCaptcha () {
      getCaptcha().then(res => {
        if (res.status === 200) {
          const imgURL = 'data:image/png;base64,' + btoa(new Uint8Array(res.data).reduce((data, byte) => data + String.fromCharCode(byte), ''))
          this.captchaURL = imgURL
        } else {
          this.$message.eroor('获取验证码失败')
        }
      })
    }
  }
}
</script>

<style scoped>
.container {
  background: url('../assets/bgimg.jpg');
  background-size:cover;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

}
.logoContainer img{
  z-index: 1;
  width:100px;
  height:100px;
  position: absolute;
}
.loginContainer{
  height: 500px;
  display: flex;
  align-items:center;
  flex-direction:column
}
.mainLogin{
  z-index: 2;
  height: 250px;
  width: 300px;
  padding: 15px;
  border-radius: 20px;
  background-color: rgba(0,0,0,0.4);
}
.loginInput{
  width:200px;
}
.loginBtn{
  color: #409EFF
}
.loginBtn:hover{
  color:#33FFBA
}
.loginTitle{
  width: 790px;
  z-index: 2;
  font-size: 55px;
  margin-bottom: 30px;
  color: #e53935;
  font-family: SimSun;
  font-weight: bold
}
</style>
<style>
.loginInput input{
  background-color: rgba(0,0,0,0.4);
  border-radius: 8px;
  color: #ffffff;
}
</style>
